import { SecureAction } from '../secure-actions';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class AlarmHistorySecureAction extends SecureAction {
  public static readonly VIEW: SecureAction = new AlarmHistorySecureAction('device:alarms:history|view');
  public static readonly EXPORT_CSV: SecureAction = new AlarmHistorySecureAction('device:alarms:history:csv|save');
  public static readonly UPDATE: SecureAction = new AlarmHistorySecureAction('device:alarms:history|update');

  private constructor(name: string) {
    super(name);
  }
}
